import { useEffect } from 'react';
import {
    trackVideoStarted,
    trackVideoProgress25Percent,
    trackVideoProgress50Percent,
    trackVideoProgress75Percent,
    trackVideoEnded,
} from '../../../../utils/adform';
import debounce from 'lodash/debounce';

const DEBOUCE_TIMEOUT = 1000;

const debounceTrackVideoStarted = debounce(trackVideoStarted, DEBOUCE_TIMEOUT);
const debounceTrackVideoProgress25Percent = debounce(trackVideoProgress25Percent, DEBOUCE_TIMEOUT);
const debounceTrackVideoProgress50Percent = debounce(trackVideoProgress50Percent, DEBOUCE_TIMEOUT);
const debounceTrackVideoProgress75Percent = debounce(trackVideoProgress75Percent, DEBOUCE_TIMEOUT);
const debounceTrackVideoEnded = debounce(trackVideoEnded, DEBOUCE_TIMEOUT);

const ProgressTracking = ({ position, videoLength }) => {
    useEffect(() => {
        const roundedPosition = Math.round(position);
        const fiftyPercentProgress = Math.round(videoLength / 2);
        const twentyFivePercentProgress = Math.round(videoLength / 4);
        const seventyFivePercentProgress = Math.round((videoLength / 4) * 3);

        if (roundedPosition >= 1 && roundedPosition < 2) {
            debounceTrackVideoStarted();
        }

        if (roundedPosition === twentyFivePercentProgress) {
            debounceTrackVideoProgress25Percent();
        }

        if (roundedPosition === fiftyPercentProgress) {
            debounceTrackVideoProgress50Percent();
        }

        if (roundedPosition === seventyFivePercentProgress) {
            debounceTrackVideoProgress75Percent();
        }

        if (roundedPosition === videoLength) {
            debounceTrackVideoEnded();
        }
    }, [position, videoLength]);

    return null;
};

export default ProgressTracking;
